import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GLOBAL } from 'src/app/services/global';
import { HomeComponent } from '../../home/home.component';
@Component({
    selector: "page-auxUrl",
    templateUrl: "auxUrl.component.html",
    styleUrls: ["./auxUrl.component.css"]
})

export class AuxUrlComponent{
  public filedomSeguimientoUrl = GLOBAL.filedomSeguimientoUrl;
  public acotado = GLOBAL.acotado;
  public nombreMuni = GLOBAL.nombreMuni;
  public pruebaPrototipo = GLOBAL.pruebaPrototipo;

  constructor(private dialog: MatDialog, private _router:Router ){

  }
  sign(tipo) {
    //  alert(tipo);
    if (sessionStorage.getItem("identity-domCloud") && sessionStorage.getItem("token-domCloud")) {
      this.dialog.closeAll();
      if (tipo == 'expediente') {
        // console.log("expediente 1");
        //this._router.navigate([`/expedientes`]);
        this._router.navigate([`/certificados`]);
      } else if (tipo == 'seguimiento_expediente') {
        // console.log("seguimiento expediente 1");
        window.open(`${GLOBAL.seguimientoSolicitudes}`, "_blank")
        // this._router.navigate([`/seguimiento_expediente`]);
      } else if (tipo=='seguimiento_expediente2'){
        console.log("seguimiento expediente 2");
        //window.open(`${GLOBAL.seguimientoSolicitudes}`, "_blank")
          this._router.navigate([`/seguimiento-expediente`]);
       }
    } else {
      if (tipo == 'expediente') {
        //console.log("expediente 2");
        localStorage.setItem("navdomcloud", 'expedientes')
        this.dialog.open(HomeComponent, {
          data: {
            url: 'expedientes'
          }
        })
      } else if (tipo == 'seguimiento_expediente') {
        // console.log("seguimiento expediente 2");
        localStorage.setItem("navdomcloud", 'seguimiento_expediente')
        window.open(`${GLOBAL.seguimientoSolicitudes}`, "_blank")

      }else if (tipo=='seguimiento_expediente2'){
        console.log("seguimiento expediente 2b");
        this.dialog.closeAll();
        this._router.navigate([`/seguimiento-expediente`]);
        
      }
    }
  }
  
}
